const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",
    // customer_id: {
    //     "ui:widget": "customer-selector",
    //     "ui:options": {
    //         label: false, // Oculta el título del campo
    //     }
    // },
    // report_id: {
    //     "ui:widget": "report-selector",
    //     "ui:options": {
    //         label: false // Oculta el título del campo
    //     }
    // },
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
  },
  widgets: {
    // 'report-selector': ReportSelector,
    // 'customer-selector': CustomerSelector
  },
};
const getFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getFilterUIConfig;
